import { TranslateService } from '@ngx-translate/core';
import { MultilanguageText } from '../../core/av-api';

export const languages_name = {
  en: {name: "nameen"},
  de: {name: "namede"},
  fr: {name: "namefr"},
  it: {name: "nameit"}
};


export function translateName(name: MultilanguageText,
                              translateService: TranslateService): string {

  if (!name) {
    return '';
  }

  let deutsch;
  let franzoesisch;
  let italienisch;
  let englisch;

  for (const localizedText of name.localizedTexts) {
    if (localizedText.sprache === 'DEUTSCH') {
      deutsch = localizedText.text;
    } else if (localizedText.sprache === 'FRANZOESISCH') {
      franzoesisch = localizedText.text;
    } else if (localizedText.sprache === 'ITALIENISCH') {
      italienisch = localizedText.text;
    } else if (localizedText.sprache === 'ENGLISCH') {
      englisch = localizedText.text;
    }
  }

  function translate() {
    switch (translateService.currentLang) {
      case 'de':
        return deutsch;
      case 'fr':
        return franzoesisch;
      case 'it':
        return italienisch;
      case 'en':
        return englisch;
    }
  }

  function translateToNextBest() {
    if (deutsch) {
      return deutsch;
    }
    if (franzoesisch) {
      return franzoesisch;
    }
    if (italienisch) {
      return italienisch;
    }
    if (englisch) {
      return englisch;
    }
  }

  const tranlatedName = translate();
  return tranlatedName ? tranlatedName : translateToNextBest();
}

